import { v4 as uuidv4 } from "uuid";

import {
  GET_BOATS_CARDS_LIST,
  GET_BOAT_CARD_INFO,
  GET_DATA_BY_SEARCH_PARAMS_BOAT,
  SET_SEARCH_PARAMS_BOATS,
  ADD_NEW_BOAT_INFO,
  EDIT_BOAT_INFO,
  GET_PAGINATION_DATA_BY_SEARCH_PARAMS_BOAT,
  UPDATE_BOAT_INFO,
  UPDATE_BOAT_INFO_FOR_ID,
  GET_CHECK_BOAT_SERIAL_NUMBER,
  UPDATE_BOAT_INFO_API,
  CHANGE_BOAT_INFO,
  REMOVE_ARREST_BOAT_INFO,
  DELETE_BOAT_FILE,
  CLEAR_BOAT_INFO,
  SET_PAGE_INDEX_BOATS,
  UPDATE_BOAT_INFO_FOR_ID_DEALS,
} from "../types";

const initialState = {
  data: [],
  paginationData: {},
  boatInfo: {
    fileList: [],
  },
  editDataResult: "",
  signName: "",
  checkboatSerialNumber: "",
  searchParams: {
    ownerSurname: "",
    ownerName: "",
    ownerMidname: "",
    regNum: "",
    leName: "",
    leUnp: "",
    boatVin: "",
    engvin: "",
    cardStatusCode: 1,
  },
  pageIndex: 0,
};

export const smallBoatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOATS_CARDS_LIST:
      return (() => ({
        ...state,
        data: [...action.data],
      }))();
    case GET_BOAT_CARD_INFO:
      const sign = action.data.documents?.find((item) => item.docnote === "signature");
      return (() => ({
        ...state,
        boatInfo: Object.assign({}, action.data),
        signName: !!sign ? sign.docname : "",
      }))();
    case SET_SEARCH_PARAMS_BOATS:
      return (() => ({
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      }))();
    case SET_PAGE_INDEX_BOATS: {
      return (() => ({
        ...state,
        pageIndex: action.data,
      }))();
    }
    case GET_DATA_BY_SEARCH_PARAMS_BOAT:
      return (() => ({
        ...state,
        data: [...action.data],
      }))();
    case GET_PAGINATION_DATA_BY_SEARCH_PARAMS_BOAT:
      return (() => ({
        ...state,
        paginationData: action.data,
      }))();
    case CLEAR_BOAT_INFO:
      return {
        ...state,
        checkboatSerialNumber: "",
        editDataResult: "",
        boatInfo: {
          fileList: [],
        },
      };
    case UPDATE_BOAT_INFO:
      return {
        ...state,
        boatInfo: { ...state.boatInfo, [action.data.key]: [action.data.data] },
      };
    case UPDATE_BOAT_INFO_FOR_ID:
      action.data.data.engineTypes = action.data.data.engineTypeIdName || action.data.data.engineTypes;
      return {
        ...state,
        boatInfo: {
          ...state.boatInfo,
          [action.data.key]: state.boatInfo[action.data.key].map((item) =>
            item.engstatid === action.data.data.engstatid ? action.data.data : item,
          ),
        },
      };
    case UPDATE_BOAT_INFO_FOR_ID_DEALS:
      return {
        ...state,
        boatInfo: {
          ...state.boatInfo,
          [action.data.key]: state.boatInfo[action.data.key].map((item) =>
            item.dealId === action.data.data.dealId ? action.data.data : item,
          ),
        },
      };
    case REMOVE_ARREST_BOAT_INFO:
      return {
        ...state,
        boatInfo: {
          ...state.boatInfo,
          boatArrestsDtos: [
            ...state.boatInfo.boatArrestsDtos.map((item) =>
              item.id === action.data.data.id ? action.data.data : item,
            ),
          ],
        },
      };
    case CHANGE_BOAT_INFO:
      return {
        ...state,
        boatInfo: {
          ...state.boatInfo,
          [action.data.key]: state.boatInfo[action.data.key].map((item) =>
            item.id === action.data.data.id ? action.data.data : item,
          ),
        },
      };
    case GET_CHECK_BOAT_SERIAL_NUMBER:
      return {
        ...state,
        checkboatSerialNumber: action.data.response,
        boatInfo: {
          ...state.boatInfo,
          mainInformation:
            action.data.response === "success"
              ? {
                  ...action.data.data,
                  regNum: state.boatInfo.mainInformation.regNum,
                }
              : state.boatInfo.mainInformation,
        },
      };
    case UPDATE_BOAT_INFO_API:
      return {
        ...state,
        editDataResult: action.data,
      };
    case ADD_NEW_BOAT_INFO:
      if (action.data.key === "documents") {
        action.data.data.id = action.data.data.id ? action.data.data.id : uuidv4();
      }
      if (action.data.key === "documents") {
        return {
          ...state,
          boatInfo: {
            ...state.boatInfo,
            fileList: state.boatInfo.fileList
              ? [...state.boatInfo.fileList, action.data.data]
              : [action.data.data],
          },
        };
      }
      return {
        ...state,
        boatInfo: {
          ...state.boatInfo,
          [action.data.key]: [...state.boatInfo[action.data.key], action.data.data],
        },
      };
    // switch (action.data.tableType) {
    //   case "dealsHistoryTableColumns":
    //     return (() => ({
    //       ...state,
    //       boatInfo: {
    //         ...state.boatInfo,
    //         boatDeals: [action.data.newInfo, ...state.boatInfo.boatDeals],
    //       },
    //     }))();
    //   case "specialMarksTableColumns":
    //     return (() => ({
    //       ...state,
    //       boatInfo: {
    //         ...state.boatInfo,
    //         specMarks: [action.data.newInfo, ...state.boatInfo.specMarks],
    //       },
    //     }))();
    //   case "boatArrestsTableColumns":
    //     return (() => ({
    //       ...state,
    //       boatInfo: {
    //         ...state.boatInfo,
    //         boatArrests: [action.data.newInfo, ...state.boatInfo.boatArrests],
    //       },
    //     }))();
    //   case "documentsTableColumns":
    //     return (() => ({
    //       ...state,
    //       boatInfo: {
    //         ...state.boatInfo,
    //         documentsDtos: [action.data.newInfo, ...state.boatInfo.documentsDtos],
    //         signName: action.data.fileType ? action.data.newInfo.docname : "",
    //       },
    //     }))();
    //   default:
    //     break;
    // }
    // break;
    case DELETE_BOAT_FILE: {
      return {
        ...state,
        boatInfo: {
          ...state.boatInfo,
          documents: state.boatInfo.documents
            ? [...state.boatInfo.documents?.filter((item) => item.docid !== action.data)]
            : [],
          fileList: state.boatInfo.fileList
            ? [...state.boatInfo.fileList.filter((item) => item.id !== action.data)]
            : [],
        },
      };
    }
    case EDIT_BOAT_INFO:
      switch (action.data.tableType) {
        case "dealsHistoryTableColumns":
          return (() => ({
            ...state,
            boatInfo: {
              ...state.boatInfo,
              boatDeals: [
                ...state.boatInfo.boatDeals.map((item) =>
                  item.dealId === action.data.newInfo.dealId ? action.data.newInfo : item,
                ),
              ],
            },
          }))();
        case "specialMarksTableColumns":
          return (() => ({
            ...state,
            boatInfo: {
              ...state.boatInfo,
              specMarks: [
                ...state.boatInfo.specMarks.map((item) =>
                  item.bsmId === action.data.newInfo.bsmId ? action.data.newInfo : item,
                ),
              ],
            },
          }))();
        case "boatArrestsTableColumns":
          return (() => ({
            ...state,
            boatInfo: {
              ...state.boatInfo,
              boatArrestsDtos: [
                ...state.boatInfo.boatArrestsDtos.map((item) =>
                  item.arrId === action.data.newInfo.arrId ? action.data.newInfo : item,
                ),
              ],
            },
          }))();
        case "documentsTableColumns":
          return (() => ({
            ...state,
            boatInfo: {
              ...state.boatInfo,
              documentsDtos: [
                ...state.boatInfo.documentsDtos.filter((item) => item.docid !== action.data.newInfo),
              ],
              signName: action.data.fileType === "file" ? state.signName : "",
            },
          }))();
        default:
          break;
      }
      break;
    default:
      return state;
  }
};
